export const validationContexts = {
  apply: "apply",
  saveTemplate: "save-template",
} as const;

export type ZValidationContext =
  (typeof validationContexts)[keyof typeof validationContexts];
